<template>
  <div class="fill-height of-y">
    <v-row no-gutters class="of-y fill-height">
      <v-col class="fill-height of-y" cols="3">
        <multi-select-list
            :items="sortedJobDescriptions"
            itemKey="id"
            :showCheckBoxes="true"
            :multiple="false"
            headlineKey="description"
            v-model="selectedId"
            filterLabel="Filter Job Descriptions"
        >
          <div slot="header" class="px-2 pt-2">
            <v-btn
                small
                block
                color="primary"
                @click="createShow = !createShow"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Job Description
            </v-btn>
          </div>
        </multi-select-list>
      </v-col>
      <divider color="primary darken-1" :vertical="true"/>
      <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedItem">
        <v-card>
          <ModifyJobDescription :edit-job-description="selectedItem" @save="upsertItem($event)"/>
        </v-card>
      </v-col>
      <v-dialog
          v-if="createShow && createObj"
          v-model="createShow"
          :width="400"
          persistent
      >
        <v-card>
          <ModifyJobDescription :edit-job-description="createObj" @dismiss="createShow = !createShow" @save="upsertItem($event)"/>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyJobDescription from "./ModifyJobDescription.vue";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";

export default {
  components: {Divider, ModifyJobDescription, MultiSelectList},
  data() {
    return {
      selectedId: null,
      createObj: {id: null, description: null},
      createShow: false,
    }
  },
  watch: {
    createShow(val) {
      if (val)
        this.createObj = {id: null, description: null}
    }
  },
  methods: {
    async upsertItem(event) {
      let {jobDescription, ref} = event;
      ref.loading = true;
      try {
        const eventID = await this.$newReq('POST', `setup/jobDescription`, jobDescription)
        const addedId = (await waitForEvent(eventID)).jobDescriptions.pop().id
        this.createShow = false
        this.selectedId = addedId;
        this.$snack.info('Changes saved')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        ref.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['jobDescriptions']),
    sortedJobDescriptions() {
      return [...this.jobDescriptions].sort((a, b) => (a.description || '').localeCompare(b.description || ''))
    },
    selectedItem() {
      if (!this.selectedId) return null
      return this.jobDescriptions.find(obj => obj.id === this.selectedId)
    }
  },
}
</script>
